import debounce from 'lodash/debounce'

const SET_ROUTE_MENU = 'SET_ROUTE_MENU'
const TOGGLE_MENU = 'TOGGLE_MENU'
const TOGGLE_MENU_MOBILE = 'TOGGLE_MENU_MOBILE'
const SET_WIDTH = 'SET_WIDTH'
const SET_HEIGHT = 'SET_HEIGHT'
const TOGGLE_DISTRACTION_FREE = 'TOGGLE_DISTRACTION_FREE'

const visualStore = {
  namespaced: false,
  state: {
    window: {
      width: window.innerWidth,
      height: window.innerHeight,
    },
    distractionFree: false,
    menuVisible: true,
    menuVisibleMobile: false,
    routeHasMenu: false,
  },
  mutations: {
    [SET_ROUTE_MENU](state, routeHasMenu) {
      state.routeHasMenu = routeHasMenu
    },
    [SET_WIDTH](state) {
      state.window.width = window.innerWidth
    },
    [SET_HEIGHT](state) {
      state.window.height = window.innerheight
    },
    [TOGGLE_MENU_MOBILE](state) {
      state.menuVisibleMobile = !state.menuVisibleMobile
    },
    [TOGGLE_MENU](state) {
      state.menuVisibleMobile = !state.menuVisibleMobile
      state.menuVisible = !state.menuVisible
    },
    [TOGGLE_DISTRACTION_FREE](state, visible) {
      state.distractionFree = !state.distractionFree
    },
  },
  getters: {
    isDistractionFree(state) {
      return state.distractionFree
    },
    hasMenu(state, getters) {
      if (state.distractionFree) return false
      if (getters.isLarge) return false
      return state.routeHasMenu
    },
    isSmall(state) {
      if (state.window.width > 640) return false
      return true
    },
    isLarge(state) {
      if (state.window.width > 1024) return true
      return false
    },
    menuState(state, getters) {
      if (getters.isLarge) return state.menuVisible
      if (getters.isSmall) return state.menuVisibleMobile
      return state.menuVisible
    },
    isMenuVisible(state, getters) {
      if (state.distractionFree) return false
      return getters.menuState
    },
  },
  actions: {
    setRouteMenu({ commit, state }, to) {
      const routeHasMenu = to.matched.some((m) => m.meta.menu)
      if (routeHasMenu !== state.routeHasMenu) {
        commit(SET_ROUTE_MENU, routeHasMenu)
      }
    },
    closeMenu({ getters, dispatch }) {
      if (getters.isMenuVisible && getters.isSmall) {
        dispatch('toggleMenu')
      }
    },
    toggleDistractionFree({ commit, getters, dispatch }) {
      commit(TOGGLE_DISTRACTION_FREE)
      if (
        !getters.isSmall &&
        !getters.menuState &&
        !getters.isDistractionFree
      ) {
        dispatch('toggleMenu')
      }
    },
    toggleMenu({ commit, state, getters }) {
      if (getters.isSmall) commit(TOGGLE_MENU_MOBILE)
      else commit(TOGGLE_MENU)
    },
  },
}

const plugin = (store) => {
  window.addEventListener('keyup', (e) => {
    const names = ['input', 'select']
    if (!names.includes(e.target.nodeName.toLowerCase())) {
      // TODO: Add HELP menu with shortcuts
      if (e.which === 77) {
        store.dispatch('toggleMenu')
      }
      if (e.which === 68) {
        store.dispatch('toggleDistractionFree')
      }
    }
  })
  const events = ['resize', 'orientationchange']
  for (const eventName of events) {
    window.addEventListener(
      eventName,
      debounce(
        () => {
          store.commit(SET_WIDTH)
          store.commit(SET_WIDTH)
        },
        200,
        { leading: true }
      )
    )
  }

  store.registerModule('visual', visualStore)
}

export default plugin
